import { render } from "./TheNewSidebar.vue?vue&type=template&id=851125fc&scoped=true"
import script from "./TheNewSidebar.vue?vue&type=script&lang=js"
export * from "./TheNewSidebar.vue?vue&type=script&lang=js"

import "./TheNewSidebar.vue?vue&type=style&index=0&id=851125fc&scoped=true&lang=css"
import "./TheNewSidebar.vue?vue&type=style&index=1&id=851125fc&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-851125fc"

export default script